import { Box, Button, HStack, Stack, Text, Avatar } from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";

import toPrecision from "util/toPrecision";
import formatter from "util/formatter";

import constants from "config/constant";
import useCoinInfo from "hooks/useCoinInfo";

const WalletBalance = ({
  onClick,
  coin,
  balance,
  precision,
  forcePrecision,
  ...xprops
}) => {
  const { image, label } = useCoinInfo(coin);

  console.log("BALANCE", toPrecision(balance, coin));

  return (
    <Button
      d="flex"
      bg="#FCFCFC"
      flexDir="row"
      variant="unstyled"
      minW={["100%", "100%", "375px"]}
      maxH="fit-content"
      maxW="fit-content"
      borderRadius="10px"
      border="1px solid transparent"
      rightIcon={<Box fontSize="xl" as={ChevronRightIcon} />}
      justifyContent="space-between"
      p="16px"
      h="fit-content"
      _focus={{
        borderColor: "var(--primary)",
        shadow: "0 0 0 3px var(--focusColor)",
      }}
      onClick={onClick}
      {...xprops}
    >
      <HStack>
        <Avatar size="md" src={image} objectFit="cover" bg="transparent" />
        <Stack alignItems="flex-start">
          <Text fontSize="sm" fontWeight="600" color="var(--primary)">
            {label} Wallet
          </Text>
          <Text
            mt="0 !important"
            fontSize="sm"
            fontWeight="600"
            color="#14142B"
          >
            {constants.fiats?.includes(coin)
              ? formatter(coin).format(balance)
              : toPrecision(balance, coin, true, precision, forcePrecision)}
          </Text>
        </Stack>
      </HStack>
    </Button>
  );
};

export default WalletBalance;
